module.exports = __webpack_public_path__ + "img/117.84abc32c.png";